import React from "react";
import { useNavigate } from "react-router-dom";
import  LogoContainer from '../../../../../shared/components/LogoContainer'


const BudgetSetup = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <LogoContainer/>
      <div className="card-setup">
        <h2 className="txt-page-heading">Enter your Fixed Expenses</h2>
        <p className="p-tag-below-heading text-center">
          Enter your monthly fixed recurring expenses. You<br />
          can upload from a file or enter manually.
        </p>
        <div className="w-full flex flex-col items-center">
          <div className="flex flex-row justify-center gap-6 w-full max-w-lg mb-24 mt-24">
            <button
              className="btn-back flex-1"
              onClick={() => navigate("/budget/upload")}
              type="button"
            >
              Upload from a file
            </button>
            <button
              className="btn-continue flex-1"
              onClick={() => navigate("/budget/manual")}
              type="button"
            >
              Enter manually
            </button>
          </div>
        </div>
        {/* Action buttons row */}
        <div className="flex flex-row justify-between items-center w-full mt-16">
          <button
            className="btn-back"
            onClick={() => navigate(-1)}
            type="button"
          >
            Back
          </button>
          <button
            className="btn-continue"
            onClick={() => navigate('/saving')}
            type="button"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default BudgetSetup;